<template>
    <div class="container-fluid">
       <div class="row">
           <div class="col-12">
               <div class="card card-form">
                   <div class="card-header">
                       <div class="row">
                           <div class="col-12">
                               <div class="pull-left">
                                   <h4 class="card-title float-left" v-if="action === 'edit'">{{$t('client.add.titlePhysical')}}</h4>
                                   <h4 class="card-title float-left" v-else-if="action === 'view'">{{$t('client.titleAddEditPhysical')}}</h4>
                               </div>
                           </div>
                       </div>
                   </div>
                   <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t('client.field.lastName')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="client.lastname">
                                    <div class="red" v-if="$v.client.lastname.$error">
                                        {{$t("client.validation.lastName")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.firstName')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="client.firstname">
                                    <div class="red" v-if="$v.client.firstname.$error">
                                        {{$t("client.validation.firstName")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.midName')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="client.midname">
                                    <div class="red" v-if="$v.client.midname.$error">
                                        {{$t("client.validation.midName")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.province')}} <span class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="client.province"
                                            :filterable="false"
                                            :options="provinces"
                                            @search="onProvinceSearch"
                                            @search:focus="onProvinceFocus"
                                            @change="onProvinceChange"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.client.province.$error">
                                        {{$t("client.validation.province")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.region')}} <span class="red">*</span></label>
                                    <v-select
                                            label="name"
                                            v-model="client.region"
                                            :filterable="false"
                                            :options="regions"
                                            @search="onRegionSearch"
                                            @search:focus="onRegionFocus"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.client.region.$error">
                                        {{$t("client.validation.region")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.address')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="client.address">
                                    <div class="red" v-if="$v.client.address.$error">
                                        {{$t("client.validation.address")}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t('client.field.phone')}} <span class="red">*</span></label>
                                    <the-mask type="text" class="form-control"
                                              v-model="client.phone"
                                              mask="+(998) ##-###-####" placeholder="+998 (XX) XXX XXXX"
                                              masked="masked"
                                    >
                                    </the-mask>
                                    <div class="red" v-if="!$v.client.phone.required">{{$t("client.validation.phone")}}</div>
                                    <div class="red" v-if="!$v.client.phone.minLength">{{$t("client.validation.minText")}}{{$v.client.phone.$params.minLength.min}}{{$t("client.validation.minValid")}}</div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.passportNumber')}} <span class="red">*</span></label>
                                    <the-mask type="text" class="form-control"
                                              mask="AA #######" :masked="true" placeholder="AA 1234567"
                                              v-model="client.passportNumber"
                                    ></the-mask>
                                    <div class="red" v-if="!$v.client.passportNumber.required">{{$t("client.validation.passportNumber")}}</div>
                                    <div class="red" v-if="!$v.client.passportNumber.minLength">{{$t("client.validation.minText")}}{{$v.client.passportNumber.$params.minLength.min}}{{$t("client.validation.minValid")}}</div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.pinflNumber')}} <span class="red">*</span></label>
                                    <pinfl-input
                                        :pinfl.sync="client.pinflNumber"
                                        :validation-field="$v.client.pinflNumber"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.passportDate')}} <span class="red">*</span></label>
                                    <datepicker class="form-control" format="dd/MM/yyyy"
                                                v-model="passportDate"
                                                :clear-button="true"
                                    ></datepicker>
                                    <div class="red" v-if="$v.passportDate.$error">{{$t("client.validation.passportDate")}}</div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('client.field.passportGivePlace')}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="client.passportGivePlace">
                                    <div class="red" v-if="$v.client.passportGivePlace.$error">
                                        {{$t("client.validation.passportGivePlace")}}
                                    </div>
                                </div>
                            </div>
                        </div>
                       <div class="row mt-5">
                           <div class="col-12 btns-box">
                               <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                   {{$t("action.cancel")}}
                               </button>
                               <button class="all-btn add-btn" v-if="action!== 'view'" @click="save" :disabled="processing">
                                   <i v-if="processing" class="fa fa-spinner fa-spin"></i>
                                   {{$t("action.save")}}
                               </button>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import {TheMask} from 'vue-the-mask';
    import Datepicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    import {required, minLength} from 'vuelidate/lib/validators';
    import {pinflNumber} from "@/shared/pinfl-birthdate/pinfl-birthdate-validator";
    import PinflInput from "@/components/PinflInput.vue";

    export default {
        components: {
            TheMask,
            Datepicker,
            PinflInput
        },
        data() {
            return {
                processing: false,
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                action: 'edit',
                client: {
                    id: null,
                    clientType: 'Physical',
                    lastname: '',
                    firstname: '',
                    midname: '',
                    province: {},
                    region: {},
                    address: '',
                    passportNumber: '',
                    pinflNumber: '',
                    phone: '',
                    passportDate: null,
                    passportGivePlace: ''
                },
                provinces: [],
                regions: [],
                passportDate: null
            }
        },
        validations() {
            return {
                client: {
                    firstname: {
                        required: required
                    },
                    lastname: {
                        required: required
                    },
                    midname: {
                        required: required
                    },
                    province: {
                        required: required
                    },
                    region: {
                        required: required
                    },
                    address: {
                        required: required
                    },
                    passportNumber: {
                        required: required,
                        minLength: minLength(10)
                    },
                    phone: {
                        required: required,
                        minLength: minLength(18)
                    },
                    pinflNumber: {
                        required: required,
                        pinflNumber: pinflNumber()
                    },
                    passportGivePlace: {
                        required: required
                    }
                },
                passportDate: {
                    required: required
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (this.$route && this.$route.params && this.$route.params.action && this.$route.params.action.length > 0) {
                    vm.action = this.$route.params.action;
                }

                if (id != null) {
                    this.$http.get(`admin/client/${id}`)
                        .then(res => {
                            const resData = res.data;
                            if (resData && resData.code === 'NOT_FOUND') {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.client.notFound'),
                                    type: 'error'
                                });
                                return;
                            }
                            vm.passportDate = parseDate(resData.passportDate);
                            vm.client = resData;
                        }, err => {
                            console.log(err)
                    })
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;
                if (this.passportDate) {
                    this.client.passportDate = formatDate(this.passportDate);
                }

                this.$http.post('/admin/client/save', this.client)
                    .then(res => {
                        this.processing = false;
                        if (res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.client.success'),
                                type: 'success'
                            });
                            this.$router.push('/client/physical/list')
                        } else if (res.data.status === 'FAIL') {
                            const results = res.data.data;
                            let htmlMsg = `<span>${this.$t('messages.client.fail')}</span><br/><table class="table"><tr><td>#</td><td>${this.$t('client.field.fullName')}</td><td>${this.$t('client.field.passportNumber')}</td><td>${this.$t('client.field.createdDate')}</td></tr>`;
                            results.forEach(client => {
                                htmlMsg += `<tr><td>${client.id}</td><td>${client.fullName}</td><td>${client.passportNumber}</td><td>${new Date(client.createDate).toLocaleDateString()}</td></tr>`;
                            });
                            htmlMsg +="</table>";
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('messages.client.fail'),
                                type: 'warning',
                                html: htmlMsg
                            });
                        }
                    }, () => {
                        this.processing = false;
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.client.error'),
                            type: 'error'
                        });
                    })
            },
            cancel() {
                this.$router.push('/client/physical/list')
            },
            onProvinceChange() {
                if (this.client.province.id && this.client.province.id > 0) {
                    if (this.regions.length > 0) {
                        this.client.region = {}
                    }
                }
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.client.province && this.client.province.id) ? this.client.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.client.province && this.client.province.id) ? this.client.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.init()
        }
    }
</script>
<style scoped>

</style>